import { Table, Tbody, Td, Th, Thead, Tr } from "@/components/ui";
import type { RolAdmin } from "../services/roles-service";
import { RolRow } from "./RolRow";

export function RolesTable({ roles }: { roles: RolAdmin[] }) {
  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Rol</Th>
          <Th>Descripción</Th>
          <Th>Tipo</Th>
          <Th align="center">Usuarios</Th>
          <Th>Permisos</Th>
          <Th align="right">Acciones</Th>
        </Tr>
      </Thead>
      <Tbody>
        {roles.length === 0 ? (
          <Tr>
            <Td colSpan={6} align="center">
              Sin roles.
            </Td>
          </Tr>
        ) : (
          roles.map((rol) => <RolRow key={rol.id} rol={rol} />)
        )}
      </Tbody>
    </Table>
  );
}
